import { ValidationFile } from 'src/redux/billing/billing.types';

export function getValidationFileSource(file: ValidationFile): string | undefined {
  return file.source ?? file.data?.[0]?.source;
}

export function validationFileKey(source: string, filename: string): string {
  return `${source}:${filename}`;
}
